import React from 'react';


const CheckOut = () => {

    return (
        <div>
            <h2>this is chackout page and its secret!!!</h2>
  
        </div>
    );
};

export default CheckOut;